<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{$t('create-customer')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="create" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<span class="title">{{$t('credentials')}}</span>
								<div class="field-inner">
									<label for="code">{{$t('code')}}*</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="code" id="code" required>
									</div>
									<label for="password">{{$t('password')}}*</label>
									<!-- <div class="element">
										<input type="password" placeholder=" " v-model="password" id="password" required>
									</div> -->
									<div class="element">
										<div class="input-addon">
											<input required class="input-addon-field" type="text" placeholder=" " id="password" v-model="password">
											<span class="input-addon-item clickable" @click.prevent="generatePassword">{{$t('generate')}}</span>
										</div>
									</div>
									<label for="confirm-password">{{$t('confirm-password')}}*</label>
									<div class="element">
										<input type="password" placeholder=" " v-model="confirmPassword" id="confirm-password" required>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<span class="title">{{$t('basic-information')}}</span>
								<div class="field-inner">
									<label for="name">{{$t('name')}}*</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="name" id="name" required>
									</div>
									<label for="vat-number">{{$t('vat-number')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="vatNumber" id="vat-number">
									</div>
									<label for="tax-code">{{$t('tax-code')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="taxCode" id="tax-code">
									</div>
									<label for="email">{{$t('email')}}</label>
									<div class="element">
										<input type="email" placeholder=" " v-model="email" id="email">
										<div class="requirements">{{$t('customer-email-requirements')}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<span class="title">{{$t('additional-information')}}</span>
								<div class="field-inner">
									<label for="address">{{$t('address')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="address" id="address">
									</div>
									<label for="country">{{$t('country')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="country" id="country">
									</div>
									<label for="zip-code">{{$t('zip-code')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="zipCode" id="zip-code">
									</div>
									<label for="city">{{$t('city')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="city" id="city">
									</div>
									<label for="province">{{$t('province')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="province" id="province">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<span class="title">{{$t('contacts-information')}}</span>
								<div class="field-inner">
									<label for="phone">{{$t('phone')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="phone" id="phone">
									</div>
									<label for="mobile-phone">{{$t('mobile-phone')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="mobilePhone" id="mobile-phone">
									</div>
									<label for="fax">{{$t('fax')}}</label>
									<div class="element">
										<input type="text" placeholder=" " v-model="fax" id="fax">
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<div class="container">
						<div class="content">
							<button class="">{{$t('create')}}</button>
						</div>
					</div>
				</form>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	data() {
		return {
			name: '',
			vatNumber: '',
			taxCode: '',
			code: '',
			email: '',
			password: '',
			confirmPassword: '',
			address: '',
			country: '',
			zipCode: '',
			city: '',
			province: '',
			phone: '',
			mobilePhone: '',
			fax: '',
			creationError: false,
		}
	},
	methods: {
		create() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			
			this.creationError = false;

			if (!this.name ||
				!this.code ||
				!this.password ||
				!this.confirmPassword) {
				this.creationError = true;
				this.$snack.danger(this.$t('compile-all-required-fields'));
			}

			if (this.password !== this.confirmPassword) {
				this.creationError = true;
				this.$snack.danger(this.$t('passwords-does-not-match'));
			}

			if (!this.creationError) {
				let params = new URLSearchParams();

				params.append('name', this.name);
				params.append('code', this.code);
				params.append('password', this.password);

				if (this.vatNumber.length) params.append('vatNumber', this.vatNumber);
				if (this.taxCode.length) params.append('taxCode', this.taxCode);
				if (this.address.length) params.append('address', this.address);
				if (this.country.length) params.append('country', this.country);
				if (this.zipCode.length) params.append('zipCode', this.zipCode);
				if (this.city.length) params.append('city', this.city);
				if (this.province.length) params.append('province', this.province);

				if (this.email.length) params.append('email', this.email);
				if (this.phone.length) params.append('phone', this.phone);
				if (this.mobilePhone.length) params.append('mobilePhone', this.mobilePhone);
				if (this.fax.length) params.append('fax', this.fax);

				let self = this;
				axios.post(`/customers/create`, params)
				.then((response) => {
					self.$snack.success(self.$t('created-successfully'));
					self.$router.push(self.$route.query.redirect || {name: 'customer', params: {id: response.data.response.insertId}});
				})
				.catch((err) => {
					let resp = err.response;
					if (resp.data.response && resp.data.response.duplicate) {
						switch (resp.data.response.duplicate) {
							case 'name':
								self.$snack.danger(self.$t('duplicate-name-error'));
								break;
							case 'code':
								self.$snack.danger(self.$t('duplicate-code-error'));
								break;
							case 'email':
								self.$snack.danger(self.$t('duplicate-email-error'));
								break;
							case 'vat_number':
								self.$snack.danger(self.$t('duplicate-vat-number-error'));
								break;
							case 'tax_code':
								self.$snack.danger(self.$t('duplicate-tax-code-error'));
								break;
						}
					} else {
						self.$snack.danger(self.$t('creation-error'));
					}
					self.creationError = true;
					if (navigator.vibrate){
						navigator.vibrate([500]);
					}
				});
			}
		},
		generatePassword() {
			let code = '';
			while (code.length < 6) {
				let digit = Math.floor(Math.random() * 10);
				code += digit;
			}
			this.password = code;
		}
	}
}
</script>